import { render, staticRenderFns } from "./AstaOrder.vue?vue&type=template&id=64e133ea&scoped=true&"
import script from "./AstaOrder.vue?vue&type=script&lang=js&"
export * from "./AstaOrder.vue?vue&type=script&lang=js&"
import style0 from "./AstaOrder.vue?vue&type=style&index=0&id=64e133ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e133ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64e133ea')) {
      api.createRecord('64e133ea', component.options)
    } else {
      api.reload('64e133ea', component.options)
    }
    module.hot.accept("./AstaOrder.vue?vue&type=template&id=64e133ea&scoped=true&", function () {
      api.rerender('64e133ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/AstaOrder.vue"
export default component.exports